'use client';

import { useEffect } from 'react';

/**
 * Client bootstrap to patch non-standard URL.parse usage in some environments/libraries.
 * Safari (and browsers generally) do not provide URL.parse. If a dependency
 * attempts to call it, we shim it to use the WHATWG URL constructor instead.
 */
export default function ClientBoot() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const g = window as any;

    if (g.URL && typeof g.URL.parse !== 'function') {
      try {
        g.URL.parse = function (input: string, base?: string | URL) {
          try {
            // Prefer explicit base if provided; otherwise fallback to current location
            return base ? new g.URL(input, base) : new g.URL(input, g.location?.href);
          } catch {
            // As a last resort, try without a base
            return new g.URL(input);
          }
        };
      } catch {
        // no-op: if we cannot define the shim, ignore to avoid breaking execution
      }
    }
  }, []);

  return null;
}
